import React from 'react';
import { Radio } from 'antd';

const VariantPricingMode = ({ value, onChange }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '11px', fontWeight: 800, color: '#475569', textTransform: 'uppercase' }}>
                Pricing Mode
            </span>
            <Radio.Group 
                value={value} 
                onChange={e => onChange(e.target.value)} 
                size="small"
                buttonStyle="solid"
            >
                <Radio.Button value={true} style={{ fontWeight: 600, fontSize: '11px' }}>Auto Margin</Radio.Button>
                <Radio.Button value={false} style={{ fontWeight: 600, fontSize: '11px' }}>Manual Pricing</Radio.Button>
            </Radio.Group>
        </div>
    );
};

export default React.memo(VariantPricingMode);
